import {PATH} from './comcon'

export const $PATH = PATH